import React from 'react';
import { sanitizedInnerHtml } from 'src/utils/sanitize';
import Typography from '@mui/material/Typography';
import CustomDialog from 'src/components/UI/dialog/CustomDialog';

export default function EmbedContentModal({
  open,
  setOpen,
  text,
  title = 'Info'
}) {
  return (
    <CustomDialog
      title={title}
      open={open}
      handleClose={() => setOpen(false)}
      minHeight="auto"
      showCancelBtn
      saveBtnLabel="Close"
    >
      <div dangerouslySetInnerHTML={sanitizedInnerHtml(text)} />
    </CustomDialog>
  );
}
